const links = {
  MUSEUM: 'https://www.neprajz.hu/',
  ETNOSHOP: 'https://etnoshop.hu/',
  PIXELPERFECTAWARDS: 'https://ppawards.hu/2022/dijazottak.php',
  HU_MUSEUMLEGALNOTICE: 'https://neprajz.hu/gyujtemenyek/reprodukcios-szolgaltatasok.html',
  EN_MUSEUMLEGALNOTICE: 'https://neprajz.hu/en/gyujtemenyek/duplication-services.html',
}

export default links
